"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import { useConsent } from "@/context/ConsentContext";

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export default function GoogleAnalytics() {
	const pathname = usePathname();
	const prevPathRef = useRef<string | null>(null);
	const { consent } = useConsent();

	useEffect(() => {
		if (consent !== "all" || !GA_MEASUREMENT_ID || typeof window === "undefined" || !window.gtag) return;
		// Initial page_view is sent by the inline config script; only send on client-side route change
		const prev = prevPathRef.current;
		prevPathRef.current = pathname;
		if (prev != null && prev !== pathname) {
			window.gtag("config", GA_MEASUREMENT_ID, {
				page_path: pathname,
			});
		}
	}, [pathname, consent]);

	// Load Google Analytics only when user has accepted all cookies
	if (!GA_MEASUREMENT_ID || consent !== "all") return null;

	return (
		<>
			<Script
				src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
				strategy="afterInteractive"
			/>
			<Script id="google-analytics" strategy="afterInteractive">
				{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', { page_path: window.location.pathname });
        `}
			</Script>
		</>
	);
}
